import { handleActions, createAction } from 'redux-actions';
import update from 'immutability-helper';
import mapActions from '@goodwaygroup/react-map-actions';

// Actions
export const actions = mapActions([
    'FETCH_DATA',
    'FETCH_DATA_SUCCESS',
    'FETCH_CREATIVES',
    'FETCH_CREATIVES_SUCCESS',
    'FETCH_DYNAMIC_CREATIVES',
    'FETCH_DYNAMIC_CREATIVES_SUCCESS',
    'FETCH_CALLOUTS',
    'FETCH_CALLOUTS_SUCCESS',
    'FETCH_TARGETING_TACTICS',
    'FETCH_TARGETING_TACTICS_SUCCESS',
    'RESET_TO_INITIAL_STATE',
    'REQUEST_CHANNEL_UPSELL',
    'SHOWED_CHANNEL_UPSELL',
], 'CHANNEL');


// Action Creators
export const fetchChannel = createAction(actions.FETCH_DATA, params => params);
export const fetchChannelSuccess = createAction(actions.FETCH_DATA_SUCCESS, data => data);
export const fetchChannelCreatives = createAction(actions.FETCH_CREATIVES, params => params);
export const fetchChannelCreativesSuccess = createAction(actions.FETCH_CREATIVES_SUCCESS, data => data);
export const fetchChannelDynamicCreatives = createAction(actions.FETCH_DYNAMIC_CREATIVES, params => params);
export const fetchChannelDynamicCreativesSuccess = createAction(actions.FETCH_DYNAMIC_CREATIVES_SUCCESS, data => data);
export const fetchChannelTargetingTactics = createAction(actions.FETCH_TARGETING_TACTICS, params => params);
export const fetchChannelTargetingTacticsSuccess = createAction(actions.FETCH_TARGETING_TACTICS_SUCCESS, data => data);
export const fetchChannelCallouts = createAction(actions.FETCH_CALLOUTS, params => params);
export const fetchChannelCalloutsSuccess = createAction(actions.FETCH_CALLOUTS_SUCCESS, data => data);
export const resetChannelInitialState = createAction(actions.RESET_TO_INITIAL_STATE);
export const requestChannelUpsell = createAction(actions.REQUEST_CHANNEL_UPSELL);
export const showedChannelUpsell = createAction(actions.SHOWED_CHANNEL_UPSELL);

// Reducers
const initialChannelState = {
    callouts: null,
    creatives: null,
    dynamicCreatives: null,
    targetingTactics: null,
    data: null,
    xAxisLabel: null,
    statistics: null,
    categories: null,
    apiConfig: null,
    channel: null,
    hasData: false
};

const initialState = {
    display: initialChannelState,
    mobile: initialChannelState,
    native: initialChannelState,
    video: initialChannelState,
    sem: initialChannelState,
    audio: initialChannelState,
    social: initialChannelState,
    tv: initialChannelState,
    site: initialChannelState,
    youtube: initialChannelState,
};

export default handleActions({

    [actions.FETCH_DATA_SUCCESS]: (state, action) => {
        const hasData = action.payload.params.hasData;

        if (hasData) {
            const rootState = action.getState();
            const scopeKey = action.payload.categories.config.selector;

            const updatedData = {
                hasData,
                channel: action.payload.params.tactic,
                data: action.payload[scopeKey],
                statistics: action.payload.statistics,
                categories: action.payload.categories[scopeKey],
                xAxisLabel: action.payload.categories.config.xAxisLabel,
                apiConfig: rootState.config.selectedTimeRange.apiConfig,
            };
            return update(state, {
                // $merging because $set clobbers callouts
                // that are generally requested at nearly the same time
                [action.payload.params.tactic]: { $merge: updatedData }
            });
        }

        const updatedData = Object.assign({}, initialChannelState);
        updatedData.hasData = hasData;
        updatedData.channel = action.payload.params.tactic;
        return update(state, {
            // $merging because $set clobbers callouts
            // that are generally requested at nearly the same time
            [action.payload.params.tactic]: { $merge: updatedData }
        });
    },

    [actions.FETCH_TARGETING_TACTICS_SUCCESS]: (state, action) => update(state, {
        [action.payload.params.segment]: {
            $merge: {
                targetingTactics: action.payload
            }
        }
    }),

    [actions.FETCH_CREATIVES_SUCCESS]: (state, action) => update(state, {
        [action.payload.params.segment]: {
            $merge: {
                creatives: action.payload
            }
        }
    }),

    [actions.FETCH_DYNAMIC_CREATIVES_SUCCESS]: (state, action) => update(state, {
        [action.payload.params.segment]: {
            $merge: {
                dynamicCreatives: action.payload
            }
        }
    }),

    [actions.FETCH_CALLOUTS_SUCCESS]: (state, action) => update(state, {
        [action.payload.params.tactic]: {
            $merge: {
                callouts: action.payload
            }
        }
    }),

    [actions.RESET_TO_INITIAL_STATE]: state => update(state, { $set: initialState })
}, initialState);



// WEBPACK FOOTER //
// ./src/services/channel/duck.js